// @ts-ignore
import { UserRole } from "../../api/generated";
// @ts-ignore
import HomeIcon from "./HomeIcon.svg?react";
import { HomeButton, StyledTabs, Tab, DropdownContainer } from "./Tabs.styles";
import { useState } from "react";
import { Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function Tabs({
  value,
  onChange,
  userRole,
}: {
  value: string;
  onChange: (event: React.SyntheticEvent, value: string) => void;
  userRole: string;
}) {

  return (
    <StyledTabs
      TabIndicatorProps={{ style: {backgroundColor: '#392e85',
        height: 2,
        borderRadius: 0, } }}
      value={value}
      onChange={onChange}
    >

      {/* Invoices Tab */}
      <Tab label="Invoices" value="invoices" />

      {/* Conditional Tabs */}
      {userRole?.toLowerCase() === UserRole.USER && (
        <Tab label="My performance" value="my-performance" />
      )}
      {(userRole?.toLowerCase() === UserRole.TEAM_LEAD ||
        userRole?.toLowerCase() === UserRole.CLIENT_ADMIN ||
        userRole?.toLowerCase() === UserRole.SYSTEM_ADMIN) && (
        <Tab label="Team performance" value="team-performance" />
      )}
    </StyledTabs>
  );
}
